import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ResultAnalysisFarrowingsTableItem } from 'shared/api/api';
import { localized } from 'shared/state/i18n/i18n';
import { ViewWeb } from 'web/view/components/utils/web-view';
import { Heading } from '../../../utils/heading';
import { AnalysisModalMapStateToProps, AnalysisModalPropsFromParent } from '../../analysis-helper';
import { AnalysisModalHeader } from '../analysis-modal-header';
import AnalysisResultsAnalysisFarrowingsTable, {
	AnalysisResultsAnalysisFarrowingsTable as AnalysisResultsAnalysisFarrowingsTableRef,
} from './analysis-results-analysis-farrowings-table';
import { onlyUnique } from 'shared/helpers/general-helpers';
import { GetAnalysisResultAnalysisFarrowingsTable } from 'shared/state/ducks/analysis/analysis-modal/operation';
import { generatePeriodDto } from 'web/web-helpers/pdf-helper/analysis-pdf-helpers/analysis-pdf-helper';
import { ClipLoader } from 'react-spinners';
import { Colors } from 'shared/assets/root-assets/colors';

interface State {
	loading: boolean;
	count: number;
	data: ResultAnalysisFarrowingsTableItem[];
}

const mapDispatchToProps = (dispatch: Dispatch, props: AnalysisModalPropsFromParent) => {
	return {
		GetAnalysisResultAnalysisFarrowingsTable: async (siteId: string) =>
			await GetAnalysisResultAnalysisFarrowingsTable(
				siteId,
				props.fetchDataValue,
				props.mode,
				props.dateFrom,
				props.dateTo,
			),
	};
};

type Props = ReturnType<typeof AnalysisModalMapStateToProps> &
	ReturnType<typeof mapDispatchToProps> &
	AnalysisModalPropsFromParent;

export class AnalysisResultsPerLitterFarrowingsOverview extends React.PureComponent<Props, State> {
	public analysisResultsAnalysisFarrowingsTableRef: AnalysisResultsAnalysisFarrowingsTableRef | undefined;
	constructor(props: Props) {
		super(props);
		this.state = { loading: true, data: [], count: 0 };
	}

	public componentDidMount() {
		this.props
			.GetAnalysisResultAnalysisFarrowingsTable(this.props.siteId)
			.then(tableData => this.setState({ data: tableData, loading: false, count: this.getCount(tableData) }));
	}

	public render() {
		return (
			<ViewWeb>
				<Heading text={localized('Farrowings')} />
				<AnalysisModalHeader
					mode={this.props.mode}
					closeModal={this.props.closeModal}
					count={this.state.count}
					value={this.props.fetchDataValue}
					dateFrom={this.props.dateFrom}
					dateTo={this.props.dateTo}
					printData={this.printData}
				/>

				{this.state.loading ? (
					<ViewWeb className="align-items-center basic-padding">
						<ClipLoader color={Colors.yellow} size={100} />
					</ViewWeb>
				) : (
					<AnalysisResultsAnalysisFarrowingsTable
						mode={this.props.mode}
						onFilterChange={this.setCount}
						data={this.state.data}
						ref={this.setRef as any}
					/>
				)}
			</ViewWeb>
		);
	}

	private setCount = (data: ResultAnalysisFarrowingsTableItem[]) => {
		this.setState({ count: this.getCount(data) });
	};

	private getCount = (data: ResultAnalysisFarrowingsTableItem[]) => {
		return data.map(tableItem => tableItem.pregnancyId).filter(onlyUnique).length;
	};

	private setRef = (ref?: AnalysisResultsAnalysisFarrowingsTableRef) =>
		{this.analysisResultsAnalysisFarrowingsTableRef = ref};

	private printData = async () => {
		if (this.analysisResultsAnalysisFarrowingsTableRef) {
			await this.analysisResultsAnalysisFarrowingsTableRef.printData(
				generatePeriodDto(this.props.dateFrom, this.props.dateTo),
			);
		}
	};
}

export default connect(AnalysisModalMapStateToProps, mapDispatchToProps)(AnalysisResultsPerLitterFarrowingsOverview);
